/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function () {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
})();

function format_number(num) {
  let NumberFormat = new Intl.NumberFormat('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);

  return NumberFormat;
}

function isMobile() {
  return (/android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i).test(navigator.userAgent);
}

function format_number_sin_decimal(num) {
  let NumberFormat = new Intl.NumberFormat('es-UY', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(num);

  return NumberFormat;
}

(function () {

  "use strict";

  var myApp = {

  }

  myApp.init = function () {

    const isLoggedIn =
      typeof logged_in_suscribed_email != 'undefined' ?
        true :
        false;

    let userData = {};
    var $contentOfertas = $('#content-ofertas');

    const $modalEstablecimiento= $('#modal-establecimiento');

    var location = window.location.pathname;

    var header = $('#header');

    var smoothScrollRural = $('.smooth-scroll-rural');
    var headerFixedHeight = $('.navbar-header').outerHeight(true) || 0 + 10;

    var $formLoginChangePass = $('.js-form-login-change-pass');

    var navbarCollapse = $('.navbar-collapse');
    var $dropdownNavbarMenu = $(".dropdown-navbar-menu");
    var $navbarDropdownToggle = $(
      "#dropdown-navbar-toggle, #dropdown-navbar-toggle-mobile"
    );

    var ticking = false;
    var last_known_scroll_position;

    var sponsorSlides = $('.sponsors-slides');

    var slidesLotMedia = $('.slides-lot-media');

    var $slidesCardsHome = $('.slides-cards-home');
    var $slidesCardBaseFeatures = $('.slides-cards-base-features');


    // slides card live vertical

    var $cardLiveVertical = $('.slide-card-live-vertical');

    // card live grouped
    var $cardLiveGrouped = $('.slide-card-live-grouped');

    // card calendar slide
    var $slidesCalendar = $('.slides-calendar-auctions');


    // remates destacados slides /cartelera
    var rematesDestacados = $('.remates-destacados-slides');

    var $servicesBoxesSlides = $('.slides-services-boxes');

    var $slidesCardHighlighted = $('.slides-card-highlighted');
    var $slidesAlmostEnded = $('.slides-almost-ended');


    var empresaBannerSlides = $('.empresa-banner-slides');

    var mobileCardSlides = $('.mobile-card-slides');
    var cardSlides = $('.card-slides');

    // company slides
    var companiesSlides = $('.companies-slides');

    // images slides
    const slidesImages = $('.slides-images');

    const $btnClipboard = $('.btn-clipboard-copy');

    if (window.location.pathname == '/') {
      $('[data-toggle="tooltip"]').tooltip();
    }

    $navbarDropdownToggle.on('click', function (event) {
        $navbarDropdownToggle.attr('aria-expanded', $navbarDropdownToggle.attr('aria-expanded') == 'false' ? 'true' : 'false');
        $navbarDropdownToggle.closest('.dropdown-navbar-menu').toggleClass('open');
        $('html').toggleClass('show-backdrop');
    });

    $('html').on('click', function (e) {
      if (!$navbarDropdownToggle.is(e.target)
          && $navbarDropdownToggle.has(e.target).length === 0
          && $dropdownNavbarMenu.has(e.target).length === 0
      ) {
          $dropdownNavbarMenu.removeClass('open');
          $('html').removeClass('show-backdrop');
          $navbarDropdownToggle.attr('aria-expanded', 'false');
      }
    });


    $btnClipboard.on('click', function (ev) {
      ev.preventDefault();
      navigator.clipboard.writeText(window.location.href).then(() => {
        $(this).children('span').html('Copiado!');
        setTimeout(() => {
          $(this).children('span').html('Copiar Link');
        }, 2000);
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    });

    $('.contact-map').on('click', ev => {
      if ($(ev.target).attr('data-href')) {
        const hash = $(ev.target).attr('data-href');
        window.location.href = `/contacto/${hash}`;
      }
    })

    // lot slides
    var lotSlides = $('.lot-slides');
    var lotSlidesThumb = $('.lot-slides-thumb');

    // var vwH = window.innerHeight;
    // var scrollHeight = document.documentElement.scrollHeight;

    var $contentWithFilter = $('.content-with-filter');
    var $filter = $contentWithFilter.find('.content-filter');
    var $filterList = $filter.children('.dropdown-menu');
    var $filterListItem = $filterList.children('li');
    var $filterBtn = $filter.find('.dropdown-toggle');
    var $contentList = $contentWithFilter.find('.content-list');
    var $contentListItem = $contentList.children('li');
    var $filterBtnText = $filterBtn.find('.dropdown-default-value');
    // var filterDefaultValue = $filterBtn.find('.dropdown-default-value').text();
    var filterBtnDefaultValues = {};
    var activeFilters = {};

    // auction tabs
    var $auctionHeaderTabs = $('.auction-header-tabs');
    var $filterGroupsAuctions = $('.filter-groups-auction');
    const $stickyVideoAuction = $('.js-sticky-video-auction');

    const $modalPromptUsuario = $('.modal-prompt-usuario');
    const windowW = window.innerWidth;

    const $modalLoginToggle = $('.modal-login-toggle');
    const $modalLogin = $('.modal-login');

    $modalLoginToggle.on('click', function (ev) {
      const $btnToTab = $modalLogin.find(`a[href="${this.hash}"]`);
      $btnToTab.trigger('click');
    })

    if (windowW < 768) {
      const isUser = window.localStorage.getItem('user-type');
      const $promptChoice = $modalPromptUsuario.find('.prompt-choice-toggle');

      $promptChoice.on('click', function (ev) {
        const userType = $(this).attr('data-user-type');
        window.localStorage.setItem('user-type', userType);
        hideModalPrompt();
      });

      // mobile
      setTimeout(function () {
        if (!isUser && $modalPromptUsuario.length) {
          $modalPromptUsuario.show(0);
          $modalPromptUsuario.css({
            'transform': 'translateY(0)',
          });
          $('html').addClass('show-backdrop');
        }
      }, 1000);

      const $modalPromptClose = $modalPromptUsuario.find('.modal-close');

      $modalPromptClose.on('click', function (ev) {
        hideModalPrompt();
      });

      function hideModalPrompt() {
        $modalPromptUsuario.css({
          'transform': 'translateY(100%)',
        }).on('transitionend', function (ev) {
          $('html').removeClass('show-backdrop');
          $modalPromptUsuario.hide();
        });
      }
    }

    ruralApp.options.isOnePage = false;

    ruralApp.Flexslider.initFlex('.flexslider', { animation: 'fade' });

    const gallery = ruralApp.MagnificPopup.initMagnific('.gallery', {
      delegate: 'a',
      mainClass: 'gallery-lightbox',
      type: 'image',
      gallery: { enabled: true },
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-gallery-arrow mfp-arrow-%dir%"></button>',
      closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-gallery-close">&#215;</button>'
    });

    const galleryDeps = ruralApp.MagnificPopup.initMagnific('.gallery-deps', {
      delegate: 'a',
      mainClass: 'gallery-lightbox',
      type: 'image',
      gallery: { enabled: true },
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-gallery-arrow mfp-arrow-%dir%"></button>',
      closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-gallery-close">&#215;</button>'
    });

    const imageZoom = ruralApp.MagnificPopup.initMagnific('.image-zoom-container', {
      type: 'image' ,
      delete: 'a'
    });

    // retrieve user data
    user.fetchUser();

    // when user data is ready
    window.addEventListener('user_data_loaded', ev => {
      userData = user.get();

      // check if user has email verified, if not add a warning
      hasEmailAndPhoneVerified();

      // if page is inmueble or contact
      if ((
        location.slice(1, 11) == 'inmuebles/' ||
        location.slice(1, 10) == 'inmueble/' ||
        location.slice(1, 9) == 'contacto'
      ) && isLoggedIn
      ) {
        fillFormData();
      }
    });

    $modalEstablecimiento.on('hidden.bs.modal', function (ev) {
      window.location.reload();
      return false;
    });

    $formLoginChangePass.on('click', function (ev) {
      const $tabsLogin = $(this).closest('.tabs-login');
      // const $tabsLinks = $tabsLogin.find('.nav-tabs');
      // const $tabPass = $tabsLinks.find(`a[href="${$(this).attr('href')}"]`);
      const $formLogin = $tabsLogin.find('.form-login');
      const $userName = $formLogin.find("#_username");
      const $formForgotPass = $tabsLogin.find('.form-forgot-pass');
      const $formForgotPassUser = $formForgotPass.find('#olvide_contrasena_usuario');

      if ($userName.val()) {
        $formForgotPassUser.val($userName.val());
      }

      // $tabPass.trigger('click');
    });

    function hasEmailAndPhoneVerified() {
      const { email_verificado, telefono_verificado } = userData;
      if (!email_verificado) {
        const message = `Por favor, debes verificar tu email`;
        // show messages
        const $accountTooltip = $('.js-account-tooltip');

        $accountTooltip.attr('title', message);
        $accountTooltip.removeClass('hidden');
        $accountTooltip.tooltip();
      }
    }

    smoothScrollRural.on('click', function (ev) {
      ev.preventDefault();
      if (window.location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && window.location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - headerFixedHeight - 30
          }, 1000);
          return false;
        }
      }
    });

    //intialized remates slides home
    if (!(typeof $.fn.slick === 'undefined')) {

      if ($slidesCardBaseFeatures.length) {
        // $slidesCardBaseFeatures.slick({
        //   dots: false,
        //   arrows: false,
        //   infinite: true,
        //   speed: 300,
        //   touchMove: false,
        //   swipe: false,
        //   swipeToSlide: false,
        //   slidesToShow: 1,
        //   variableWidth: true
        // });

      }

      if ($slidesCardsHome.length) {
        $slidesCardsHome.slick({
          mobileFirst: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 1368,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: false,
                infinite: true,
                autoplay: true,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                rows: 1,
                dots: true,
                arrows: false,
                infinite: true,
                autoplay: true,
              }
            },
            {
              breakpoint: 1,
              settings: {
                dots: true,
                arrows: false,
                infinite: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 3000,
                rows: 1,
              }
            },
          ]
        });
      }

      if ($servicesBoxesSlides.length) {
        $servicesBoxesSlides.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          arrows: false,
          dots: true,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              dots: true,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 768,
              dots: true,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                rows: 1,
                slidesPerRow: 1,
              }
            },
            {
              breakpoint: 0,
              dots: true,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 4,
              }
            },
          ]
        });
      }

      if (slidesImages.length) {
        slidesImages.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: false,
          dots: true,
          autoplaySpeed: 3000,
        });
      }

      if (slidesLotMedia.length) {
        slidesLotMedia.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          draggable: true,
          dots: false,
          autoplaySpeed: 3000,
        });
      }

      if (rematesDestacados.length) {
        rematesDestacados.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          dots: false,
          autoplaySpeed: 3000,
        });
      }

      if (empresaBannerSlides.length) {
        empresaBannerSlides.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          dots: false,
          autoplaySpeed: 3000,
        });
      }

      if (sponsorSlides.length) {
        sponsorSlides.slick({
          lazyLoad: 'ondemand',
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          arrows: false,
          dots: true,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              dots: true,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },
            {
              breakpoint: 768,
              dots: true,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 576,
              dots: true,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 360,
              dots: true,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 0,
              dots: true,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
          ]
        });
      }

      if (companiesSlides.length) {
        companiesSlides.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: false,
          dots: true,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 7
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 360,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 0,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }

      if (mobileCardSlides.length) {
        mobileCardSlides.slick({
          autoplay: true,
          arrows: false,
          dots: true,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 0,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }

      if ($slidesCalendar.length) {
        $slidesCalendar.slick({
          autoplay: false,
          arrows: false,
          dots: true,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                dots: true,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                dots: true,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 0,
              settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }

      if ($slidesAlmostEnded.length) {
        $slidesAlmostEnded.slick({
          autoplay: true,
          arrows: true,
          dots: false,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                dots: false,
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 0,
              settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }

      if ($slidesCardHighlighted.length) {
        $slidesCardHighlighted.slick({
          autoplay: true,
          arrows: true,
          dots: false,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                dots: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                dots: false,
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 0,
              settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }

      if (cardSlides.length) {
        cardSlides.slick({
          autoplay: true,
          arrows: false,
          dots: false,
          autoplaySpeed: 3000,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                dots: false,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: false,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 576,
              settings: {
                dots: true,
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 0,
              settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '40px'
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }

      if (lotSlides.length) {
        lotSlides.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          swipe: false,
          autoplay: true,
          autoplaySpeed: 3000,
          pauseOnHover: true,
          infinite: false,
          fade: true,
          asNavFor: '.lot-slides-thumb'
        });
      }

      if (lotSlidesThumb.length) {
        lotSlidesThumb.slick({
          slidesToShow: 8,
          slidesToScroll: 1,
          asNavFor: '.lot-slides',
          dots: false,
          arrows: false,
          centerMode: false,
          autoplay: true,
          infinite: false,
          autoplaySpeed: 3000,
          focusOnSelect: true
        });
      }

    }

    navbarCollapse.on('hide.bs.collapse', function () {
      $('body').removeClass('without-scroll');
    });

    window.addEventListener('scroll', function (e) {
      last_known_scroll_position = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function () {
          // checkScrollPos(last_known_scroll_position);
        });
        ticking = true;
      }
    });

    function checkScrollPos(scroll_pos) {
      // var diffScroll = scrollHeight - vwH;
      if (scroll_pos > 40) {
        header.removeClass('navbar-static-top');
        header.addClass('navbar-fixed-top');
        $('body').addClass('navbar-is-fixed');
      } else {
        header.removeClass('navbar-fixed-top');
        header.addClass('navbar-static-top');
        $('body').removeClass('navbar-is-fixed');
      }
      ticking = false;
    }

    function fillFormData() {
      var $form = $('#i-contacto, #i-visit, #form_companies_contact');
      var $name = $form.find('input[name*="name"]')
      var $email = $form.find('input[name*="email"]');
      var $tel = $form.find('input[name*="tel"], input[name="visit_phone"]');

      if (userData.nombre) {
        $name.val(userData.nombre);
        if ($form.attr('id') == 'form_companies_contact') {
          $name
            .closest('.form-group')
            .addClass('hidden');
        } else {
          $name
            .closest('[class^="col-"]')
            .addClass('hidden');
        }
      }
      if (userData.email) {
        $email.val(userData.email);
        if ($form.attr('id') == 'form_companies_contact') {
          $email
            .closest('.form-group')
            .addClass('hidden');
        } else {
          $email
            .closest('[class^="col-"]')
            .addClass('hidden');
        }
      }
      if (userData.telefono) {
        $tel.val(userData.telefono);
        if ($form.attr('id') == 'form_companies_contact') {
          $tel
            .closest('.form-group')
            .addClass('hidden');
        } else {
          $tel
            .closest('[class^="col-"]')
            .addClass('hidden');
        }
      }
    }

    // Show/hide filters in auction tabs when show lot tab
    $auctionHeaderTabs.find('a[data-toggle="tab"][href="#lot"]').on('show.bs.tab', function (e) {
      $filterGroupsAuctions.removeClass('hidden');
    });

    $auctionHeaderTabs.find('a[data-toggle="tab"][href="#lot"]').on('hide.bs.tab', function (e) {
      $filterGroupsAuctions.addClass('hidden');
    });

    // DROPDOWN FILTERS

    // retrieve dropdown btn default text
    $filterBtnText.each(function (idx, el) {
      const key = $(el).closest('.filter-group-item').data('filter');
      filterBtnDefaultValues[key] = $(el).text();
    });

    $filterListItem.on('click', function (ev) {
      ev.preventDefault();
      var statusVal = $(this).data('status');
      var categoryVal = $(this).data('category');
      var locationVal = $(this).data('location');
      var companiesVal = $(this).data('companies');

      console.log($(this).data);

      if (statusVal != undefined) {
        filterItems('status', statusVal, this);
      }

      if (categoryVal != undefined) {
        filterItems('category', categoryVal, this);
      }

      if (locationVal != undefined) {
        filterItems('location', locationVal, this);
      }

      console.log(companiesVal);
      if (companiesVal != undefined) {
        filterItems('companies', companiesVal, this);
      }

      updateAccordionsCounter(this);
    });

    let $panelAlertaRemate = $('#panelAlertaRemate');
    let $mensajeAlertaRemate = $('#mensajeAlertaRemate');
    let $cerrarAlertaRemate = $('#cerrarAlertaRemate');

    function filterItems(filter, value, el) {
      activeFilters[filter] = value;
      let filtroSinLotes = true;

      $cerrarAlertaRemate.click();

      if (value != 'all') {
        $(el)
          .closest('.content-filter')
          .find('.dropdown-default-value')
          .text(value);
      } else {
        delete activeFilters[filter];
        $(el)
          .closest('.content-filter')
          .find('.dropdown-default-value')
          .text(filterBtnDefaultValues[filter]);
      }

      $contentListItem.each(function (idx, item) {
        var filterPassed = 0;
        for (var filter in activeFilters) {
          if (matchFilters(filter, item)) {
            filterPassed++;
          }
        }

        if (filterPassed == Object.keys(activeFilters).length) {
          filtroSinLotes = false;
          $(item).css('display', 'none').fadeIn('slow');
        } else {
          $(item).css('display', 'none');
        }

      });

      if(filtroSinLotes){

        $panelAlertaRemate.removeClass('hidden');
        $mensajeAlertaRemate.text('No se encontraron lotes con el filtro seleccionado.');

      }

    }

    $cerrarAlertaRemate.click(()=>{
      $panelAlertaRemate.addClass('hidden');
      $mensajeAlertaRemate.text('');
    });

    function matchFilters(filter, el) {
      var value = $(el).data(filter);

      if (activeFilters[filter] !== value) return false;
      return true;
    }

    function updateAccordionsCounter(el) {
      var accordion = $('.accordion-lot');
      accordion.each(function (idx, el) {
        var itemsVisible = $(el).find('.content-list').children('li:visible').length;
        var $categoryCount = $(el).find('.category-count');
        $categoryCount.text(itemsVisible);
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    myApp.init();
  }, false);

  new WOW({
    boxClass: 'wow',      // default
    animateClass: 'animated', // default
    offset: 0,          // default
    mobile: false,       // default
    live: false        // default
  }).init();



})();
